import { downloadFileFromUrl, downloadFileFromUrlDirectly } from "@/modules/file/download";

export const downloadImageFromUrl = async ({
  src,
  fileName,
}: {
  src: string | null;
  fileName: string;
}): Promise<void> => {
  if (!src) return;

  try {
    await downloadFileFromUrl({
      fileName,
      downloadUrl: src,
      throwOnError: true,
    });
  } catch {
    // handles images that are linked to external sources, like imgur, pinterest, etc.
    await downloadFileFromUrlDirectly({
      fileName,
      downloadUrl: src,
      inTab: true,
    });
  }
};
